import { FormattedMessage } from 'react-intl';
import AppShortcutOutlined from '@mui/icons-material/AppShortcutOutlined';
import { generatePath } from 'react-router-dom';

import { AppRoutePath } from '@ocx-app/pages/AppRoutePath';

import { List, ListItemText, ListItemStartIcon, ListItemNavLink, Paper } from '@ocx/ui';

import { profileMessages } from '../profile.messages';

export const RedeemPromocodeMenuItem = () => {
  return (
    <Paper p={0} sx={{ overflow: 'hidden' }}>
      <List>
        <ListItemNavLink to={generatePath(AppRoutePath.RedeemPromocode, { code: '' })}>
          <ListItemStartIcon>
            <AppShortcutOutlined />
          </ListItemStartIcon>
          <ListItemText>
            <FormattedMessage {...profileMessages['profile:redeem-promocode:title']} />
          </ListItemText>
        </ListItemNavLink>
      </List>
    </Paper>
  );
};
